import script from "./DetailBeritaView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailBeritaView.vue?vue&type=script&setup=true&lang=js"

import "./DetailBeritaView.vue?vue&type=style&index=0&id=1628d7f0&lang=css"

const __exports__ = script;

export default __exports__